import React, { useEffect } from 'react';
import { connect } from 'react-redux';

import { authSetRedirectUrl } from '../store/actions/index';

export default (WrappedComponent) => {
    const requireAuthentication = props => {
        useEffect(() => {
            if(!props.isAuthenticated) {
                props.dispatch(authSetRedirectUrl(props.match.url));
                props.history.push('/login');
            }
        }, [props.isAuthenticated]);

        return <WrappedComponent {...props} />;
    }

    const mapStateToProps = (state) => {
        return {
            isAuthenticated: state.auth.token !== null
        };
    }

    return connect(mapStateToProps)(requireAuthentication);
};